<mat-tab-group [(selectedIndex)]="selectedTab">
  <mat-tab label="{{ 'DETAIL' | translate }}">
    <ng-template matTabContent>
      <wim-user-detail/>
    </ng-template>
  </mat-tab>
  <mat-tab label="{{ 'ROLES' | translate }}">
    <ng-template matTabContent>
      <wim-user-roles/>
    </ng-template>
  </mat-tab>
</mat-tab-group>
